import React from 'react';
import { Heading } from '../../../_lib/components/Heading/Heading';

type GalleryHeadlineProps = {
  id: string;
  children: string;
};
export function HiddenGalleryHeadline({ id, children }: GalleryHeadlineProps) {
  return (
    <Heading id={`gallery-headline-${id}`} hierarchy={2} className="invisible">
      {children}
    </Heading>
  );
}
